import gql from 'graphql-tag';

export const UpdateParticipantTask = gql`
  mutation UpdateParticipantTask(
    $organizationId: ID!
    $participantId: ID!
    $participantTaskId: ID!
    $request: UpdateParticipantTaskRequest!
  ) {
    updateParticipantTask(
      organizationId: $organizationId
      participantId: $participantId
      participantTaskId: $participantTaskId
      request: $request
    ) {
      id
      participantId
      name
      labels {
        id
        name
        color
      }
      assignees {
        id
        name
        email
        title
      }
      dueDate
      requiresDueDate
      completedAt
      createdAt
      updatedAt
      status
    }
  }
`;
